import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=1e76af6c&scoped=true"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=1e76af6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e76af6c",
  null
  
)

export default component.exports